import BlogsSection from "./blogs";
import CTASection from "./cta";
import DevOpsSection from "./dev-ops";
import IntegrationSection from "./integrations";
import LoggedInHeroSection from "./logged-in-hero/logged-in-hero";
import LoggedOutHeroSection from "./logged-out-hero";
import ScalingSection from "./scaling";
import JiraSoftwareNav from "./software-jira-navbar";
import TabsSection from "./tabs";
import WorkflowSection from "./workflow";

export {
    BlogsSection,
    CTASection,
    DevOpsSection,
    LoggedOutHeroSection,
    LoggedInHeroSection,
    IntegrationSection,
    ScalingSection,
    JiraSoftwareNav,
    TabsSection,
    WorkflowSection
};
